"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var _SearchOption = _interopRequireDefault(require("./SearchOption"));

var MenuList =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2["default"])(MenuList, _React$Component);

  function MenuList() {
    (0, _classCallCheck2["default"])(this, MenuList);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(MenuList).apply(this, arguments));
  }

  (0, _createClass2["default"])(MenuList, [{
    key: "render",
    value: function render() {
      // eslint-disable-next-line react/prop-types
      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className,
          cx = _this$props.cx,
          getStyles = _this$props.getStyles,
          isMulti = _this$props.isMulti,
          innerRef = _this$props.innerRef,
          isLoading = _this$props.isLoading,
          selectProps = _this$props.selectProps;
      return _react["default"].createElement(_react["default"].Fragment, null, !isLoading && _react["default"].createElement(_SearchOption["default"], {
        selectProps: selectProps,
        availableOptions: children
      }), _react["default"].createElement("div", {
        css: getStyles('menuList', this.props),
        className: cx({
          'menu-list': true,
          'menu-list--is-multi': isMulti
        }, className),
        ref: innerRef
      }, children));
    }
  }]);
  return MenuList;
}(_react["default"].Component);

var _default = MenuList;
exports["default"] = _default;